import Immutable from 'immutable';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// action creators
import { doneIndicator, success } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import {
  MESSAGE_DELETE_REQUEST,
  MESSAGE_DELETE,
} from 'store/constants/messageTypes';

// schemas
import { messageSchema } from 'store/schemas/messageSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';
import getResponsePayload from 'helpers/getResponsePayload';

const WATCH_TYPE = MESSAGE_DELETE_REQUEST;
const TYPE = MESSAGE_DELETE;
const META_ID = 'delete';

export function* deleteMessageSaga(action: any): any {
  const {
    payload: { id, groupId },
  } = action;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  const response = yield* httpSaga(
    TYPE,
    call(client.delete, `/messages/${id}?group_id=${groupId}`),
    {
      metaId: META_ID,
      dispatchSuccess: false,
    }
  );

  // The reducer removes the message by the id in the response.
  // No response means httpSaga already put the error on the store
  if (response) {
    const payload = getResponsePayload(response, messageSchema);
    yield put(success(TYPE, Immutable.fromJS(payload), META_ID));
  }

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, deleteMessageSaga);
}

export default function* root() {
  yield all([fork(watch)]);
}
